@if (!field.isHidden) {
  <div>
    <mat-form-field id="inputCOMP-form" [formGroup]="group" class="custom-form-field">
      <mat-label>{{ field.displayName }}</mat-label>
      @if (field.inputType !== 'number') {
        <input
          matInput
          [formControlName]="field.name"
          [name]="field.name"
          [type]="field.inputType"
          autocomplete="off"
          [required]="field?.isRequired"
          (paste)="rstrctSpclCharPaste($event, field)"
          (keypress)="restrictSpclChar($event, field)"
        />
      }
      @if (field.inputType === 'number') {
        <input
          matInput
          [formControlName]="field.name"
          [name]="field.name"
          onkeydown="
            javascript: return event.keyCode === 190 || event.keyCode === 8 || event.keyCode === 46
              ? true
              : !isNaN(Number(event.key));
          "
          [type]="field.inputType"
          autocomplete="off"
          [required]="field?.isRequired"
        />
      }
      @for (validation of field.validations; track validation) {
        <ng-container id="inputCOMP-form-ng-container" ngProjectAs="mat-error">
          @if (group.get(field.name).hasError(validation.name)) {
            <mat-error id="inputCOMP-form-error{{ field.name }}">{{ validation.message }}</mat-error>
          }
          <!-- <mat-error id="inputCOMP-form-error{{field.name}}" *ngIf="group.get(field.name).hasError('customError')">Email Id already exists</mat-error> -->
        </ng-container>
      }
    </mat-form-field>
    @if (
      this.group.get(this.field.name).valid &&
      (field.name === 'panNumber' || field.name === 'govIdNo') &&
      selectedRole === 'ROLE_ECMS_ALL'
    ) {
      <div class="panErrorMsgDisp">{{ errorMessage }}</div>
    }
    <!-- <span class="circleicon">
        <img style="
opacity: 1;cursor: pointer;" src="assets/images/vendor_icons/icon-success-filled.png" alt="">
    </span> -->
  </div>
}
